import { stylePropertyPrefixes } from '../utilities/swan-style.utils.js';

const ROOT_CLASSNAMES = {
    base: 'swan',
    standardMode: `swan-${stylePropertyPrefixes.standardMode}`,
    darkMode: `swan-${stylePropertyPrefixes.darkMode}`,
    // compactMode: `swan-${stylePropertyPrefixes.compactMode}`,
    /**
   * @deprecated Use standardMode prop instead
   */ lightMode: `swan-${stylePropertyPrefixes.lightMode}`,
    /**
   * @deprecated Removing in v3 as part of tokens work
   */ themeHoliday: `swan-theme-holiday`
};

export { ROOT_CLASSNAMES };
